export default {
  next: 'Nächster Inhalt',
  solution: 'Lösung anzeigen',
  chooseSelectBox: 'Wähle aus'
}
